import React, { Component } from 'react';
import PropTypes from 'prop-types';

import BlogText from 'components/blog/slices/text';
import BlogQuote from 'components/blog/slices/quote';
import BlogImageGallery from 'components/blog/slices/image';
import BlogArticleList from 'components/blog/slices/articlelist';
import BlogSingleImage from 'components/blog/slices/imagesingle';
import BlogEmbedded from 'components/blog/slices/embedded';

export default class SliceZone extends Component {
  constructor (props) {
    super(props)
    this.state = {
      allSlices: []
    }
  }
  render() {
    const { allSlices } = this.props;
    if(allSlices == null)
      return null
    const slice = allSlices.map(s => {
      switch (s.slice_type) {
        case 'embedded':
          return <BlogEmbedded key={s.id} input={s} />
        case 'image_single':
          return <BlogSingleImage key={s.id} input={s} />
        case 'list_of_articles':
          return <BlogArticleList key={s.id} input={s} />
        case 'quote':
          return <BlogQuote key={s.id} input={s} />
        case 'text':
          return <BlogText key={s.id} input={s} />;
        case 'image_gallery':
          return <BlogImageGallery key={s.id} input={s} />;
        default:
          return null;
      }
    });
    return slice;

  }
}

SliceZone.propTypes = {
  allSlices: PropTypes.array.isRequired,
};